// react
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router";
// Mui
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Fade from "@mui/material/Fade";
// components
import LockPopup from "src/components/UI/Home/Menu/LockPopup";
import user from "src/components/UI/Shared/user";
// icons
import login_icon from "src/components/UI/Home/Main/assets/images/login.png";
import lock_icon from "src/assets/images/lock-icon.png";
import layers_icon from "src/components/UI/Home/Main/assets/images/layers.png";
import toolbox_icon from "src/components/UI/Home/Main/assets/images/toolbox.png";
import sign_up_icon from "src/components/UI/Home/Main/assets/images/sign-up.png";
import log_out_icon from "src/components/UI/Home/Main/assets/images/logout.png";
// styles
import styles from "src/components/UI/Home/Main/assets/scss/SideMenu.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface SideMenuProps {
  onClosePickerMode: () => void;
}
const SideMenu = ({ onClosePickerMode }: SideMenuProps) => {
  const dispatch = useDispatch();
  const pickerModeEnabled = useSelector(
    (state: any) => state.app.pickerModeEnabled
  );
  const navigate = useNavigate();
  const activePanel = useSelector((state: any) => state.app.activePanel);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openVerificationPopup, setOpenVerificationPopup] = useState(false);
  const [lockCodeIsFound, setLockCodeIsFound] = useState(false);

  const current_user = user.getCurrentLoggedIn();

  const menuFading = () => {
    if (isMenuOpen) {
      const items = document.querySelectorAll(".innerCircle");

      items.forEach((element) => {
        element.classList.add(styles.itemsFadeOut);
      });
      setTimeout(() => {
        items.forEach((element) => {
          element.classList.remove(styles.itemsFadeOut);
        });
        setIsMenuOpen(false);
      }, 250);
    } else {
      setIsMenuOpen(true);
    }
  };

  const handleToggleMenu = () => {
    menuFading();
    if (user.getLoggedInLockCode()) {
      setLockCodeIsFound(true);
    } else {
      setLockCodeIsFound(false);
    }
    if (pickerModeEnabled) {
      dispatch(appActions.setPickerModeEnabled(false));
    }
  };

  const handleToolboxClicked = () => {
    if (activePanel) navigate("/");
    dispatch(appActions.setActivePanel("toolbox"));
    dispatch(
      appActions.setSearchString({
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        menu5: "",
        menu6: "",
      })
    );
  };
  const handleLayersClicked = () => {
    navigate("layers");
  };

  const handleSignOut = () => {
    user.signOut();
  };

  const handleClickLock = () => {
    user.setLoggedInLock("locked");
    if (!lockCodeIsFound) {
      setOpenVerificationPopup(true);
    }
  };
  const handleCloseLockPopup = () => {
    setOpenVerificationPopup(false);
  };

  useEffect(() => {
    if (pickerModeEnabled) {
      setIsMenuOpen(false);
    }
  }, [pickerModeEnabled]);
  return (
    <div>
      <Paper
        id="menubtn"
        onClick={() => {
          handleToggleMenu();
          onClosePickerMode();
        }}
        elevation={3}
        className={`${styles.root}`}
      >
        <Divider className={styles.verticalLine} />
        <Divider className={styles.verticalLine} />
        <Divider
          className={styles.verticalLine}
          style={{ marginRight: "8px" }}
        />
      </Paper>
      {isMenuOpen && (
        <div className={`${styles.container}`}>
          <Tooltip
            arrow
            title="Layers"
            placement="top"
            classes={{ arrow: styles.arrow, tooltip: styles.tooltip }}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 400 }}
          >
            <Paper
              className={`${styles.item} ${
                isMenuOpen ? styles.ItemsAnimation : ""
              }`}
            >
              <div className={`${styles.innerItem} innerCircle`}>
                <IconButton
                  onClick={handleLayersClicked}
                  className={`${styles.iconButton}`}
                >
                  <Icon classes={{ root: styles.iconRoot }}>
                    <img className={styles.icon} src={layers_icon} />
                  </Icon>
                </IconButton>
              </div>
            </Paper>
          </Tooltip>
          <Tooltip
            arrow
            title={current_user !== "guest" ? "Logout" : "Login"}
            placement="left"
            classes={{ arrow: styles.arrow, tooltip: styles.tooltip }}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 400 }}
          >
            <Paper
              className={`${styles.item} ${
                isMenuOpen ? styles.ItemsAnimation : ""
              }`}
            >
              <div className={`${styles.innerItem} innerCircle`}>
                <IconButton
                  className={`${styles.iconButton}`}
                  onClick={
                    current_user !== "guest"
                      ? () => {
                          navigate("/");
                          handleSignOut();
                        }
                      : () => {
                          navigate("identity/login");
                        }
                  }
                >
                  <Icon
                    classes={{ root: styles.iconRoot }}
                    style={{
                      justifyContent:
                        current_user !== "guest" ? "flex-end" : "flex-start",
                    }}
                  >
                    <img
                      className={styles.icon}
                      src={current_user !== "guest" ? log_out_icon : login_icon}
                      style={{
                        width: current_user !== "guest" ? "30px" : "",
                        height: current_user !== "guest" ? "30px" : "",
                      }}
                    />
                  </Icon>
                </IconButton>
              </div>
            </Paper>
          </Tooltip>
          <Tooltip
            arrow
            title={current_user !== "guest" ? "Lock" : "Register"}
            placement="left"
            classes={{ arrow: styles.arrow, tooltip: styles.tooltip }}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 400 }}
          >
            <Paper
              className={`${styles.item} ${
                isMenuOpen ? styles.ItemsAnimation : ""
              }`}
            >
              <div className={`${styles.innerItem} innerCircle`}>
                <IconButton
                  className={styles.iconButton}
                  onClick={
                    current_user !== "guest"
                      ? !lockCodeIsFound
                        ? handleClickLock
                        : () => {
                            navigate("identity/lock");
                          }
                      : () => {
                          navigate("identity/register");
                        }
                  }
                  style={{ backgroundColor: "transparent" }}
                >
                  <Icon classes={{ root: styles.iconRoot }}>
                    <img
                      className={`${styles.icon}`}
                      src={current_user !== "guest" ? lock_icon : sign_up_icon}
                      style={{
                        width: current_user === "guest" ? "30px" : "",
                        height: current_user === "guest" ? "30px" : "",
                      }}
                    />
                  </Icon>
                </IconButton>
              </div>
            </Paper>
          </Tooltip>
          <Tooltip
            arrow
            title="Toolbox"
            placement="bottom"
            classes={{ arrow: styles.arrow, tooltip: styles.tooltip }}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 400 }}
          >
            <Paper
              className={`${styles.item} ${
                isMenuOpen ? styles.ItemsAnimation : ""
              }`}
            >
              <div className={`${styles.innerItem} innerCircle`}>
                <IconButton
                  className={`${styles.iconButton}`}
                  onClick={handleToolboxClicked}
                >
                  <Icon classes={{ root: styles.iconRoot }}>
                    <img className={styles.icon} src={toolbox_icon} />
                  </Icon>
                </IconButton>
              </div>
            </Paper>
          </Tooltip>
        </div>
      )}

      {openVerificationPopup && (
        <LockPopup
          openModal={openVerificationPopup}
          onClose={handleCloseLockPopup}
        />
      )}
    </div>
  );
};

export default SideMenu;
